import config from '../../../config.json'
import requestStatus from '../../../constants/requestStatus'
import OverlaySpinner from '../../overlay/presentational/OverlaySpinner'
import OverlayText from '../../overlay/presentational/OverlayText'
import Translation from '../../Translation/cont/Translation'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import EditEventFormContainer from '../cont/EditEventFormContainer'
import EditEventFormPrint from './EditEventFormPrint'
import getEventValues from '../func/getInitValues'
import actionTypes from '../../../actions/actionTypes'
import {OVERLAY_EVENTS_MAIL_YES_NO} from '../../../constants/overlayTypes'
import OverlayNonSiOhhh from '../../overlay/presentational/OverlayNonSiOhhh'

const PageEditEventPage = ({status, error, event, settings, currentLang, timezone, debug, displayOverlay, setDisplayOverlay, onUpdateEvent, onCancel, onRequestSendMail, onCancelRequestSendMail, onSendMail, uiRequestOverlay}) => {
    const pageName = "Edit Event"
    let overlay = ''

    if(uiRequestOverlay.requestType === actionTypes.EVENTS_EVENTS_SEND_MAIL_REQUEST && uiRequestOverlay.overlayType === OVERLAY_EVENTS_MAIL_YES_NO) {
        overlay = <OverlayNonSiOhhh
            titleTransId={'events_send_accepted_confirm'}
            text={error ? error.message : ''}
            nonButtonTextTransId="cancel_button"
            nonOnClickButton={() => onCancelRequestSendMail()}
            siButtonTextTransId={'events_send_accepted_confirm_yes'}
            siOnClickButton={() => onSendMail(event.id)} //ToDo: CHeck selectedItems 
        />
    } else if(requestStatus.REQUEST_PENDING == status && uiRequestOverlay.requestType === actionTypes.EVENTS_EVENTS_UPDATE_REQUEST) {
        overlay = <OverlaySpinner
        transId="data_is_loading" />
    } else if(requestStatus.REQUEST_PENDING == status && uiRequestOverlay.requestType === actionTypes.EVENTS_EVENTS_SEND_MAIL_REQUEST) {
        overlay = <OverlaySpinner
        transId="events_sending_mail" />
    } else if(displayOverlay && requestStatus.REQUEST_ERROR === status) {
        overlay = <OverlayText
            titleTransId="an_error_has_occurred"
            text={error ? error.events : ''}
            buttonTextTransId='button_close'
            onClickButton={() => setDisplayOverlay(false)}
        />
    }

    const eventData = event ? getEventValues(event) : null;

    return (
        <>
            <WrapperPageSimple pageTitle={pageName} addClassName="wrapper-event-edit" closePagePath={config.routes.events.path} overlay={overlay}>
                <div className="program-page site-content site-event site-event-edit">
                    {event ? (
                        <>
                            <div className='event-manual-change-note'>
                                <p className='text-regular'>Hinweis:</p>
                                <p className='text-small-light'>{
                                    `Die Preise, die in WordPress für Besucher:innen und Säle in Abhängigkeit von verschiedenen Veranstaltungs- und Programmarten,
                                    Uhrzeiten und Wochentagen definiert wurden, werden auf dieser Seite nicht automatisch eingefügt. Falls Sie hier Veranstaltungs- 
                                    oder Programmart, Uhzeit oder Datum editieren, müssen Sie ggf. die Preise selbst anpassen.`
                                }</p>
                            </div>
                            
                            <EditEventFormContainer
                                status={status}
                                event={event}
                                settings={settings}
                                currentLang={currentLang}
                                timezone={timezone}
                                debug={debug}
                                onUpdateEvent={onUpdateEvent}
                                onCancel={onCancel}
                                onSendMail={onRequestSendMail}
                            />
                        </>
                    ):(
                        <div><Translation id="no_data"/></div>
                    )}
                </div>
            </WrapperPageSimple>

            {eventData &&
                <EditEventFormPrint 
                    eventData={eventData}
                    settings={settings}
                    currentLang={currentLang}
                    timezone={timezone}
                    debug={debug}
                    showInBrowser={false}
                />
            }
        </>
    )
}

export default PageEditEventPage

